var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"unitDialog",attrs:{"size":"mini_mini","title":"选择单位","footerButton":_vm.unitFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultParams,"autoLoad":false,"async":false,"selectNode":_vm.selectUnitId,"multiple":_vm.multiple,"expandedFirst":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6d0677cb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/views/systemSet/org/user/unitDialog.vue
// module id = 1209
// module chunks = 0 1